import { env } from './env';

/**
 * Which surface this portal talks to.
 *
 * The review surface is the only one of the five that takes no session. It
 * authenticates a share token and nothing else - there is no login endpoint
 * here to point at, because there is no login.
 */
export const API = {
  baseUrl: env.apiBaseUrl,
  surface: '/api/review',
  /*
   * Longer than the other portals' 20 seconds. A dentist on a clinic
   * connection is fetching a mesh, not a JSON row, and timing out a model that
   * was most of the way down is worse than waiting.
   */
  timeoutMs: 45_000,

  endpoints: {
    open: '/open',
    notes: '/notes',
    decision: '/decision',
    case: '/case',
    report: '/report',
    patientLink: '/patient-link',
    patientLinkOff: '/patient-link/off',
    patientOpen: '/patient/open',
    patientAnswer: '/patient/answer',
  },
} as const;

export const apiUrl = (path: string): string => `${API.baseUrl}${API.surface}${path}`;
